const responseTable = {
    "payload": [
        {
            "recognitionCategoryId": 1,
            "categoryName": "Blue",
            "unitPrice": 10000.00
        },
        {
            "recognitionCategoryId": 2,
            "categoryName": "Green",
            "unitPrice": 20000.00
        },
        {
            "recognitionCategoryId": 3,
            "categoryName": "Gold",
            "unitPrice": 50000.00
        },
        {
            "recognitionCategoryId": 4,
            "categoryName": "Black",
            "unitPrice": 100000.00
        }
    ]
};

const responseCards = {
    "payload": [
        {
            "recognitionCategoryId": 1,
            "categoryName": "Blue",
            "icon": "https://beneflex-icons.s3.amazonaws.com/recognition_categories/blueStar.svg",
            "shapeCount": 6
        },
        {
            "recognitionCategoryId": 2,
            "categoryName": "Green",
            "icon": "https://beneflex-icons.s3.amazonaws.com/recognition_categories/greenStar.svg",
            "shapeCount": 1
        },
        {
            "recognitionCategoryId": 3,
            "categoryName": "Gold",
            "icon": "https://beneflex-icons.s3.amazonaws.com/recognition_categories/goldStar.svg",
            "shapeCount": 5
        },
        {
            "recognitionCategoryId": 4,
            "categoryName": "Black",
            "icon": "https://beneflex-icons.s3.amazonaws.com/recognition_categories/blackStar.svg",
            "shapeCount": 5
        }
    ]
};

const responseSend = {
    "payload": [
        {
            "recognitionCategoryId": 1,
            "categoryName": "Blue",
            "unitPrice": 10000.00
        },
        {
            "recognitionCategoryId": 2,
            "categoryName": "Green",
            "unitPrice": 20000.00
        },
        {
            "recognitionCategoryId": 3,
            "categoryName": "Gold",
            "unitPrice": 50000.00
        },
        {
            "recognitionCategoryId": 4,
            "categoryName": "Black",
            "unitPrice": 100000.00
        }
    ]
};

const responsePayment = {

    "payload": [
        {
            "paymentMethodId": 1,
            "paymentMethodName": "PSE",

        },
        {
            "paymentMethodId": 2,
            "paymentMethodName": "Tranferencia",

        },
        {
            "paymentMethodId": 3,
            "paymentMethodName": "Consignación",

        }
    ]
};

const responsePaymentSupport = {
    status: 200,
    data: {
        "payload": {
            "code": 200,
            "message": 'Recuerde que la fase siguiente sera el proceso de conciliación'
        }
    }
};

export const service = {

    getTable: () => new Promise(resolve => {
        setTimeout(resolve({ data: responseTable }), 1000);
    }),

    getCards: () => new Promise(resolve => {
        setTimeout(resolve({ data: responseCards }), 1000);
    }),

    postSend: () => new Promise(resolve => {
        setTimeout(resolve({ data: responseSend }), 1000);
    }),

    getPaymentMethon: () => new Promise(resolve => {
        setTimeout(resolve({ data: responsePayment }), 1000);
    }),

    postPaymentSupport: () => new Promise(resolve => {
        setTimeout(resolve({ data: responsePaymentSupport }), 1000);
    }),
}